import clsx from 'clsx';
import { useFormikContext } from 'formik';
import React, {ChangeEvent, useEffect, useRef, useState} from 'react';
import { Button, Form } from 'react-bootstrap';
import AutocompleteObjectV2 from '../../../../component/AutocompleteObjectV2';
import InputCellGroup from '../../../../component/input-cell-group';
import LabelRequired from '../../../../component/LabelRequired';
import TextField from '../../../../component/TextField';
import InsuranceCheckButton from '../insurance-check-button';
import ScanQRCccdButton from '../ScanQRCccdButton';
import InsuranceCardsButton from './InsuranceCardsButton';
import InputGroupAutocomplete from '../../../../component/input-group-autocomplete';
import { getHealthOrg } from '../../../../utils/ServicesUtils';
import {CODE, RESPONSE_MESSAGE, VARIABLE_STRING} from '../../../../utils/Constant';
import { CODE_DOI_TUONG } from '../../../constants/PhanHeTiepNhan';
import { getInsCoveragePercentage, getInsLevel } from '../../../services/TiepNhanServices';
import { IDanhSachDanhMuc } from '../../../models/TiepDonModel';
import _ from "lodash";
import {toast} from "react-toastify";

type Props = {
	isDisabled: boolean;
	handleChangeInsurance: any;
	onReadBHYTQRCode: any;
	searchBarcode: any;
	danhSachDanhMuc?: IDanhSachDanhMuc;
	isBHYT: boolean;
	formClassName?: string;
	isFromInsuranceCardsDialog?: boolean;
	baseValues?: any;
	setBaseValues?: any;
};

const InsuranceInfo = ({
	isDisabled,
	handleChangeInsurance,
	onReadBHYTQRCode,
	searchBarcode,
	danhSachDanhMuc,
	isBHYT,
	formClassName,
	isFromInsuranceCardsDialog = false,
	baseValues,
	setBaseValues,
}: Props) => {
  const {errors, touched, setFieldValue, setFormikState} = useFormikContext<any>();

	const [disabled, setDisabled] = useState(false);
	const [isMienCungChiTra, setIsMienCungChiTra] = useState(
		Boolean(baseValues?.insurance?.insurance?.isMienCungChiTra)
	);
	const [isFirstTry, setIsFirstTry] = useState(true);
	const [prevInsLevelParams, setPrevInsLevelParams] = useState<any>(null);
	const [prevInsCoveragePercentageParams, setPrevInsCoveragePercentageParams] = useState<any>(null);

	const visitValues = baseValues?.visit;
	const patientValues = baseValues?.patient;
	const insuranceValues = baseValues?.insurance;

	const container = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (patientValues?.id) {
      setIsFirstTry(true);
    }
  }, [patientValues?.id]);

	const onUpdateCard = () => {
		setDisabled(false);
	};

  const handleSetTempInsurance = (value: any = {}) => {
    setFormikState((prev: any) => {
      return ({
        ...prev,
        values: {
          ...prev.values,
          insurance: {
            ...prev.values.insurance,
            ...value,
          }
        }
      })
    });
  }

	const handleGetInsLevel = async () => {
		try {
			let params = {
				insKcbbdCode: insuranceValues?.insKcbbdCode || null,
				visitType: visitValues?.visitType?.id || null,
				appointmentId: baseValues?.appointmentId || null,
				ggtHospital: baseValues?.additionalForms?.tabGiayGioiThieu?.ggtHospital?.bvInsCode || null,
				patientId: patientValues?.id || null,
			};

			if (_.isEqual(params, prevInsLevelParams) || _.every(params, _.isNull)) {
				return;
			}

      setPrevInsLevelParams(params);
      let { data } = await getInsLevel(params)
      if (data.code === CODE.SUCCESS) {
        let insLevel = danhSachDanhMuc?.listTuyenKCB?.find(
          (item) => item?.code === data?.data?.insLevelCode
        )
        handleSetTempInsurance({
          examLevel: insLevel || null,
          insLevelCode: insLevel?.code || null,
          insLevelName: insLevel?.name || null,
        })
      }
		} catch (error) {
			console.error(error);
		}
	};

	const handleSetInsCoveragePercentage = async () => {
		try {
      const insCode = [
        insuranceValues?.insCodeDoiTuong,
        insuranceValues?.insCodeMucHuong,
        insuranceValues?.insCodeNoiPhatHanh,
        insuranceValues?.insCodeMaBhxh,
      ].join("");
			let params = {
				insCode,
				insLevelCode: insuranceValues?.examLevel?.code || insuranceValues?.insLevelCode,
			};
			if (_.isEqual(params, prevInsCoveragePercentageParams)) {
				return;
			} else {
				setPrevInsCoveragePercentageParams(params);
				let { data } = await getInsCoveragePercentage(params)
				if (data.code === CODE.SUCCESS) {
          handleSetTempInsurance({insCoveragePercentage: data?.data?.allowanceLevel || 0});
				}
			}
		} catch (error) {
			console.error(error);
		}
	};

  const getHealthOrgByInsInfo = async (insKcbbdCode: string) => {
    if (!insKcbbdCode) {return {};}
    try {
      const params = {
        pageSize: 9999,
        keyword: insKcbbdCode,
      }
      const res = await getHealthOrg(params);
      const {data, code} = res;
      if (code === CODE.SUCCESS) {
        handleSetTempInsurance({insKcbbdName: data?.content?.[0]?.name || ""});
      }
    } catch (error) {
      console.error(error);
      toast.error(RESPONSE_MESSAGE.ERROR);
    }
  };

	useEffect(() => {
		if (
      danhSachDanhMuc
      || insuranceValues?.insKcbbdCode
      || visitValues?.visitType?.id
      || baseValues?.appointmentId
      || patientValues?.id
      || baseValues?.additionalForms?.tabGiayGioiThieu?.ggtHospital?.bvInsCode
    ) {
			if (isFirstTry || insuranceValues?.id) {
				setIsFirstTry(false);
      } else {
        handleGetInsLevel();
      }
    }
  }, [
    danhSachDanhMuc,
    insuranceValues?.insKcbbdCode,
    visitValues?.visitType?.id,
    baseValues?.appointmentId,
    patientValues?.id,
    baseValues?.additionalForms?.tabGiayGioiThieu?.ggtHospital?.bvInsCode
  ]);

  useEffect(() => {
    if (insuranceValues?.insKcbbdCode && !insuranceValues?.insKcbbdName) {
      getHealthOrgByInsInfo(insuranceValues?.insKcbbdCode || "").then(r => r)
    } else if (!insuranceValues?.insKcbbdCode && !insuranceValues?.insKcbbdName) {
      handleSetTempInsurance({insKcbbdName: ""});
    }
  }, [insuranceValues?.insKcbbdCode, insuranceValues?.insKcbbdName]);

	useEffect(() => {
    const insCode = [
      insuranceValues?.insCodeDoiTuong,
      insuranceValues?.insCodeMucHuong,
      insuranceValues?.insCodeNoiPhatHanh,
      insuranceValues?.insCodeMaBhxh,
    ].join("");

		if (insCode.length === 15 && (insuranceValues?.examLevel || insuranceValues?.insLevelCode)) {
			handleSetInsCoveragePercentage().then(r => r);
		} else if (!insuranceValues?.insCodeMucHuong && !insuranceValues?.examLevel) {
      handleSetTempInsurance({insCoveragePercentage: ""});
    }
	}, [
    insuranceValues?.examLevel,
    insuranceValues?.insCodeDoiTuong,
    insuranceValues?.insCodeMucHuong,
    insuranceValues?.insCodeNoiPhatHanh,
    insuranceValues?.insCodeMaBhxh
  ])

	useEffect(() => {
		setDisabled(isDisabled);
	}, [isDisabled]);

	return (
		<div ref={container}>
			<div
				className={clsx(
					'd-flex justify-content-between',
					'spaces min-h-30 pb-8 mt-2 ps-2',
					'border-bottom-1'
				)}
			>
				<div className="d-flex gap-1 z-index-1">
					{visitValues?.id && (
						<Button className="btn-fill" onClick={onUpdateCard}>
							<i className="bi bi-credit-card-2-front-fill pe-0"></i>
              <span>Cập nhật thẻ BHYT</span>
						</Button>
					)}
					<InsuranceCheckButton
						patientInfo={{
							...baseValues,
							[VARIABLE_STRING.INSURANCE]: insuranceValues
						}}
						onUpdatePatientInfoFromInsurance={onReadBHYTQRCode}
					/>
				</div>

				<div className="d-flex">
					{(isFromInsuranceCardsDialog && visitValues?.visitObjectType?.code === CODE_DOI_TUONG.BAO_HIEM) && (
						<Button
							className="btn-fill spaces mr-4 min-w-30"
							title="Thêm mới thẻ BHYT"
							onClick={() => {
								setFieldValue(VARIABLE_STRING.INSURANCE, {});
								setDisabled(false);
							}}
						>
							<i className="bi bi-plus-lg pe-0 me-0"></i>
						</Button>
					)}
					{(!isFromInsuranceCardsDialog && visitValues?.id) && (
						<InsuranceCardsButton
							baseValues={baseValues}
							handleSetInsValuesFromBase={(data: any) => {
								setBaseValues({
									...baseValues,
									[VARIABLE_STRING.INSURANCE]: data
								})
							}}
							resetVisitObjectType={(visitObjectTypeCode: string) =>
								setFieldValue(VARIABLE_STRING.VISIT, {
									...visitValues,
									visitObjectType:
										danhSachDanhMuc?.listDoiTuong?.find(
											(item: any) => item?.code === visitObjectTypeCode
										) || null,
								})
							}
						/>
					)}
					<ScanQRCccdButton
						onReadData={searchBarcode}
						label="Thông tin trên mã QR thẻ BHYT:"
						tooltip="Quét QR thẻ BHYT"
						disabled={baseValues?.visit?.stopped}
						container={container}
					/>
				</div>
			</div>

			<div className={formClassName}>
				<div className="d-flex mb-2 mt-1">
					<div className="spaces width-100 d-flex">
						<LabelRequired label="Số BHYT" className="ps-2 min-w-80px" />
						<InputCellGroup
							cells={[
								{
									name: 'insCodeDoiTuong',
									length: 2,
									className: 'text-uppercase',
								},
								{
									name: 'insCodeMucHuong',
									length: 1,
								},
								{
									name: 'insCodeNoiPhatHanh',
									length: 2,
								},
								{
									name: 'insCodeMaBhxh',
									length: 10,
								},
							]}
							value={insuranceValues}
							onChange={(e) => {
								handleChangeInsurance(e.target.name, e.target.value);
							}}
							disabled={disabled}
							errors={errors?.insurance}
							touched={touched?.insurance}
							inputClassName="customs-input"
						/>
					</div>
				</div>

				<div className="d-flex mb-2">
					<LabelRequired label="KCB BĐ" className="ps-2 min-w-80px" />
					<InputGroupAutocomplete
						tableColumns={[
							{
								Header: 'Code',
								accessor: 'code',
							},
							{
								Header: 'Name',
								accessor: 'name',
							},
						]}
						inputConfig={[
							{
								label: 'Mã KCBBD',
								name: 'insKcbbdCode',
								config: {
									style: {
										flex: '0 1 80px',
									},
								},
								className: 'text-center',
							},
							{
								label: 'Tên KCBBD',
								name: 'insKcbbdName',
							},
						]}
						mode="remote"
						fetchApi={getHealthOrg}
						urlData="data.content"
						getParams={(values) => ({
							pageSize: 20,
							keyword: values?.insKcbbdName || values?.insKcbbdCode,
						})}
						getTableData={(data) => {
							return data?.map((row: any) => ({
								...row,
								insKcbbdCode: row.code,
								insKcbbdName: row.name,
							}));
						}}
						value={{
							insKcbbdCode: insuranceValues?.insKcbbdCode,
							insKcbbdName: insuranceValues?.insKcbbdName,
						}}
						onChange={handleSetTempInsurance}
						disabled={disabled}
					/>
				</div>

				<div className="d-flex mb-2">
					<div className="spaces width-100 d-flex align-items-center">
						<LabelRequired label="Hạn thẻ" className="ps-2 min-w-80px" />
						<InputCellGroup
							cells={[
								{
									name: 'insFromDay',
									length: 2,
								},
								{
									name: 'insFromMonth',
									length: 2,
								},
								{
									name: 'insFromYear',
									length: 4,
								},
							]}
							value={insuranceValues}
							onChange={(e) => {
                handleSetTempInsurance({[e.target.name]: e.target.value});
							}}
							disabled={disabled}
							errors={errors?.insurance}
							touched={touched?.insurance}
							inputClassName="customs-input"
							className="me-4"
						/>

						<InputCellGroup
							cells={[
								{
									name: 'insToDay',
									length: 2,
								},
								{
									name: 'insToMonth',
									length: 2,
								},
								{
									name: 'insToYear',
									length: 4,
								},
							]}
							value={insuranceValues}
							onChange={(e) => {
                handleSetTempInsurance({
                  [e.target.name]: e.target.value,
                });
							}}
							disabled={disabled}
							errors={errors?.insurance}
							touched={touched?.insurance}
							inputClassName="customs-input"
						/>
					</div>
				</div>

				<div className="d-flex mb-2">
					<div className="spaces width-100 d-flex align-items-center">
						<LabelRequired label="TGAD" className="ps-2 min-w-80px" />
						<InputCellGroup
							cells={[
								{
									name: 'effectiveFromDay',
									length: 2,
								},
								{
									name: 'effectiveFromMonth',
									length: 2,
								},
								{
									name: 'effectiveFromYear',
									length: 4,
								},
							]}
							value={insuranceValues}
							onChange={(e) => {
                handleSetTempInsurance({
                  [e.target.name]: e.target.value,
                });
							}}
							disabled={disabled}
							errors={errors?.insurance}
							touched={touched?.insurance}
							inputClassName="customs-input"
							className="me-4"
						/>

						<InputCellGroup
							cells={[
								{
									name: 'effectiveToDay',
									length: 2,
								},
								{
									name: 'effectiveToMonth',
									length: 2,
								},
								{
									name: 'effectiveToYear',
									length: 4,
								},
							]}
							value={insuranceValues}
							onChange={(e) => {
                handleSetTempInsurance({
                  [e.target.name]: e.target.value,
                });
							}}
							disabled={disabled}
							errors={errors?.insurance}
							touched={touched?.insurance}
							inputClassName="customs-input"
						/>
					</div>
				</div>

				<div className="d-flex mb-2">
					<div className="spaces d-flex w-80">
						<LabelRequired label="Tuyến KCB" className="ps-2 min-w-80px" />
						<AutocompleteObjectV2
							options={danhSachDanhMuc?.listTuyenKCB || []}
							name="examLevel"
							value={
								insuranceValues?.examLevel ||
								(insuranceValues?.insLevelCode && {
									code: insuranceValues?.insLevelCode,
									name: insuranceValues?.insLevelName,
								}) ||
								null
							}
							onChange={(selectedOption) => {
                handleSetTempInsurance({
                  examLevel: selectedOption,
                  insLevelCode: selectedOption?.code,
                  insLevelName: selectedOption?.name,
                });
							}}
							isDisabled={!isBHYT}
						/>
					</div>
					<div className="spaces d-flex position-relative">
						<TextField
							className="ps-29px no-spinners"
							label="Mức hưởng"
							name="insCoveragePercentage"
							value={insuranceValues?.insCoveragePercentage}
							onChange={(e: any) =>
								handleChangeInsurance(e.target.name, e.target.value)
							}
							type="number"
							labelClassName="spaces ps-4 min-w-90"
							disabled={true}
							inputClassName="max-w-100"
						/>
						<h6 className="position-absolute spaces top-5 right-5">%</h6>
					</div>
				</div>

				<div className="spaces d-flex ps-2 mt-10 mb-4">
					<Form.Check
						type="checkbox"
						id="insMienCungChiTra"
						className="min-w-150px d-flex align-items-center gap-2"
						disabled={disabled}
					>
						<Form.Check.Input
							type="checkbox"
							disabled={disabled}
							checked={isMienCungChiTra}
							name="isMienCungChiTra"
							onChange={(e: ChangeEvent<HTMLInputElement>) => {
								const checked = e.target.checked;
								setIsMienCungChiTra(checked);
								setFieldValue(
									`${VARIABLE_STRING.INSURANCE}.isMienCungChiTra`,
									checked
								);

								if (!checked) {
									setFieldValue(VARIABLE_STRING.INSURANCE, {
										...insuranceValues,
										isMienCungChiTra: checked,
										insNgaymienchitraDay: checked
											? insuranceValues?.insNgaymienchitraDay
											: null,
										insNgaymienchitraMonth: checked
											? insuranceValues?.insNgaymienchitraMonth
											: null,
										insNgaymienchitraYear: checked
											? insuranceValues?.insNgaymienchitraYear
											: null,
									});
								}
							}}
						/>
						<Form.Check.Label>Chứng nhận không cùng chi trả trong năm</Form.Check.Label>
					</Form.Check>
				</div>

				<div className="d-flex mb-2">
					<div className="spaces d-flex ms-2 flex-grow-1">
						<LabelRequired label="Ngày miễn cùng chi trả" className=" min-w-200px" />
						<InputCellGroup
							cells={[
								{
									name: 'insNgaymienchitraDay',
									length: 2,
								},
								{
									name: 'insNgaymienchitraMonth',
									length: 2,
								},
								{
									name: 'insNgaymienchitraYear',
									length: 4,
								},
							]}
							value={insuranceValues}
							onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
								handleChangeInsurance(e.target.name, e.target.value);
							}}
							disabled={disabled || !isMienCungChiTra}
							inputClassName="customs-input"
							errors={errors?.insurance}
							touched={touched?.insurance}
						/>
					</div>
				</div>

				<div className="d-flex mb-2">
					<div className="spaces d-flex ms-2 flex-grow-1">
						<LabelRequired
							label="Ngày đóng đủ 5 năm liên tục"
							className=" min-w-200px"
						/>
						<InputCellGroup
							cells={[
								{
									name: 'insNgaydu5namDay',
									length: 2,
								},
								{
									name: 'insNgaydu5namMonth',
									length: 2,
								},
								{
									name: 'insNgaydu5namYear',
									length: 4,
								},
							]}
							value={insuranceValues}
							onChange={(e) => {
                handleSetTempInsurance({
                  [e.target.name]: e.target.value,
                });
							}}
							disabled={disabled}
							errors={errors?.insurance}
							touched={touched?.insurance}
							inputClassName="customs-input"
						/>
					</div>
				</div>

        <div className="d-flex mb-2">
          <TextField
            className="w-100 ms-2 force-border-radius"
            label="Đ/C theo BHYT"
            name="insAddress"
            value={insuranceValues?.insAddress || ""}
            onChange={(e: any) => handleChangeInsurance(e.target.name, e.target.value)}
            as="textarea"
            rows={1}
            type="text"
            disabled={!isBHYT}
            inputClassName="w-100"
          />
        </div>
			</div>
		</div>
	);
};

export default React.memo(InsuranceInfo);
